import(/* webpackMode: "eager" */ "/var/www/gerelt/front/app/news/page.js");
